/** TODO(Morris): Remove this and make all components default to the local time zone. */
export const DEFAULT_TIME_ZONE = 'America/Los_Angeles';
export const INVALID_DATE_TIME_VALUE = 'invalid';
